import React, { useEffect,useState } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2'
import { LoadingButton } from '@mui/lab';

import API from 'src/data/api';
import palette from "../../../theme/palette"
import CustomModal from '../../custom/CustomModal';
import { fNumber } from '../../../utils/formatNumber';
import { isNullValue, validateForm } from 'src/utils/formUtil';
import CustomTextField from 'src/components/custom/CustomTextField';
import InnerCard from 'src/components/ui/InnerCard';
import { gridSize } from 'src/utils/constants';

const initDelivery = {
  volume: { value: "", required: true, error: false, errorMessage: 'Please specify collected volume by the client' },
}

export const OrderCollectionConfirmation = ({ 
  orderData,
  openModal,
  handleCloseModal,
  handleSubmitCallback,
 }) => {

  const [submitted, setSubmitted] = useState(false);
  const [delivery, setDelivery] = useState({ ...initDelivery });

  useEffect(() => {

  }, [openModal, orderData]);

  const handleSubmitDeliveryConfirmation = async () => {

    if (isNullValue(orderData?.suborder_id) || !validateForm(setDelivery, delivery)) {
      console.log("opps, validaion error", orderData)
      return;
    }

    let endPoint = `inventory/public_facing/update_suborder?suborder_id=${orderData?.suborder_id}`
      .concat(`&collected_volume=${delivery.volume.value}`);

    setSubmitted(true);
    try {
      const res = await API.patch(`${endPoint}`, '');

      if (res.status === 200 || res.status === 201) {
        handleResetAndClose();
        handleSubmitCallback();
      } else {
        console.log("Error:", res.data);
      }
    } catch (error) {
      console.error('Error uploading document:', error);
    }
    setSubmitted(false);
  }

  const handleResetAndClose = () => {
    setDelivery({ ...initDelivery });
    handleCloseModal({ isOpen: false, updateStats: null });
  }

  const handleInputChange = (field, value, error = false, message = null) => {
    const _delivery = {
      ...delivery,
      [field]: {
        ...delivery[field],
        value: value,
        error: (isNullValue(value) && delivery[field]['required']) || error,
        errorMessage: message || delivery[field]['errorMessage'],
      },
    }
    setDelivery(_delivery);
  };

  return (
    <>
      {orderData && (
        <CustomModal
          openModal={openModal}
          handleCloseModal={handleResetAndClose}
          modalTitle={"Update Track Status - Order " + orderData?.suborder_id + ""}
          modalIcon='transport'
        >
          <Typography
            variant="inherit"
            sx={{ color: palette.grey[500] }}>
            {orderData?.transporter_name || ''}

          </Typography>

          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid size={{ ...gridSize }} key='driver'>
              <InnerCard type={"Driver"} value={orderData?.driver_name} />
            </Grid>
            <Grid size={{ ...gridSize }} key='vehicle-truck'>
              <InnerCard type={"Vechile"} value={orderData?.vehicle_registration} />
            </Grid>
            <Grid size={{ ...gridSize }} key='trailer'>
              <InnerCard type={"Trailer"} value={orderData?.trailer1_registration} />
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid size={{ ...gridSize }} key='eta'>
              <InnerCard type={"volume"} value={fNumber(orderData?.volume)} />
            </Grid>
            <Grid size={{ ...gridSize }} key='volume'>
              <InnerCard type={"Product"} value={orderData?.fuel_type} />
            </Grid>
            <Grid size={{ ...gridSize }} key='remaining'>
              <InnerCard type={"Company"} value={orderData?.company_name} />
            </Grid>
          </Grid>

          <CustomTextField sx={{ my: 3 }}
            fullWidth
            type="number"
            id="volume"
            variant="outlined"
            name='volume'
            label={`Volume`}
            value={delivery?.volume.value}
            onChange={(e) => {
              const value = e.target.value;
              const error = (value < 1 || value > orderData?.volume * 1.15 );
              handleInputChange('volume', value, error);
            }}
            required={delivery?.volume.required}
            error={delivery?.volume.error}
            helperText={delivery?.volume.error && delivery?.volume.errorMessage}
          />

          <Box sx={{ display: 'flex', justifyContent: 'right', mt: 2 }}>
            <Button
              variant='contained'
              color="inherit"
              onClick={() => handleResetAndClose()}
            >
              Cancel
            </Button>

            <LoadingButton
              sx={{ ml: 2, }}
              variant="contained"
              loading={submitted}
              onClick={() => handleSubmitDeliveryConfirmation()}
            >
              Finish
            </LoadingButton>
          </Box>
        </CustomModal>
      )}
    </>
  )
}

OrderCollectionConfirmation.propTypes = {
  orderData: PropTypes.object.isRequired,
}
